import React, { useState } from 'react';
import { Step1Props, buildFullName, buildAddress } from './types';
import { UserIcon, ChevronDownIcon, PlusIcon, DocIcon, RemoveCircleIcon, PeopleIcon } from './icons';
import { AddCustomerModal } from '../../../components/add-customer-modal';

const Step1Parties: React.FC<Step1Props> = (props) => {
    const {
        t, errors, setErrors,
        personalData,
        customers, selectedCustomerId, setSelectedCustomerId,
        showCustomerDropdown, setShowCustomerDropdown,
        offeredServices, setOfferedServices,
        assignmentPeriod, setAssignmentPeriod,
        workDescription, setWorkDescription,
        specialTerms, setSpecialTerms,
        onCustomerAdded,
    } = props;

    const [showAddModal, setShowAddModal] = useState(false);

    const selectedCustomer = customers.find(c => c.customerId === selectedCustomerId);

    const clearError = (key: string) =>
        setErrors(prev => { const n = { ...prev }; delete n[key]; return n; });

    return (
        <>
        <div className="cc-card">
            <div className="cc-card-header">
                <span className="cc-card-icon"><PeopleIcon /></span>
                <div className="cc-card-heading-text">
                    <h3 className="cc-card-title">{t('CC_PARTIES_CUSTOMER_INFO')}</h3>
                </div>
            </div>
            <div className="cc-card-body">

                {/* Customer section */}
           

                <div className="cc-row-between" style={{ marginTop: 12 }}>
                    <label className="cc-label">{t('CC_PARTIES_SELECT_LABEL')}</label>
                    <button
                        className="cc-btn-tertiary cc-btn-gap"
                        type="button"
                        onClick={() => setShowAddModal(true)}
                    >
                        <PlusIcon /> {t('CC_PARTIES_ADD_CUSTOMER')}
                    </button>
                </div>

                <div className="cc-field" style={{ maxWidth: 360, position: 'relative', marginTop: 6 }}>
                    <div
                        className={`cc-custom-select${errors.customer ? ' cc-input--error' : ''}`}
                        onClick={() => setShowCustomerDropdown(s => !s)}
                    >
                        <UserIcon />
                        <span className="cc-custom-select-value">
                            {selectedCustomer?.name || t('CC_PARTIES_SELECT_PLACEHOLDER')}
                        </span>
                        <ChevronDownIcon />
                    </div>
                    {errors.customer && <span className="cc-field-error">{errors.customer}</span>}

                    {showCustomerDropdown && (
                        <div className="cc-dropdown">
                            {customers.length === 0 && (
                                <div className="cc-dropdown-item cc-dropdown-item--empty">
                                    {t('CC_PARTIES_NO_CUSTOMERS')}
                                </div>
                            )}
                            {customers.map(c => (
                                <div
                                    key={c.customerId}
                                    className="cc-dropdown-item"
                                    onClick={() => {
                                        setSelectedCustomerId(c.customerId ?? null);
                                        setShowCustomerDropdown(false);
                                        clearError('customer');
                                    }}
                                >
                                    {c.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {selectedCustomer && (
                    <div className="cc-customer-card">
                        <div className="cc-customer-doc-icon"><DocIcon /></div>
                        <div className="cc-customer-info">
                            <p className="cc-label-bold" style={{ margin: 0 }}>{selectedCustomer.name}</p>
                            <p className="cc-body-text" style={{ margin: 0 }}>
                                {[selectedCustomer.address, selectedCustomer.city, selectedCustomer.zipCode]
                                    .filter(Boolean).join(', ')}
                            </p>
                        </div>
                        <button
                            className="cc-btn-remove"
                            type="button"
                            onClick={() => setSelectedCustomerId(null)}
                        >
                            {t('CC_PARTIES_REMOVE_CUSTOMER')} <RemoveCircleIcon />
                        </button>
                    </div>
                )}

                {/* Contract details */}
                <div className="cc-grid-2" style={{ marginTop: 16 }}>
                    <div className="cc-field">
                        <label className="cc-label">{t('CC_PARTIES_OFFERED_SERVICES_LABEL')}</label>
                        <input
                            className={`cc-input${errors.offeredServices ? ' cc-input--error' : ''}`}
                            value={offeredServices}
                            onChange={e => { setOfferedServices(e.target.value); clearError('offeredServices'); }}
                            placeholder={t('CC_PARTIES_OFFERED_SERVICES_HINT')}
                        />
                        {errors.offeredServices && <span className="cc-field-error">{errors.offeredServices}</span>}
                    </div>
                    <div className="cc-field">
                        <label className="cc-label">{t('CC_PARTIES_ASSIGN_PERIOD_LABEL')}</label>
                        <input
                            className="cc-input"
                            value={assignmentPeriod}
                            onChange={e => setAssignmentPeriod(e.target.value)}
                            placeholder={t('CC_PARTIES_ASSIGN_PERIOD_HINT')}
                        />
                    </div>
                </div>

                <div className="cc-field" style={{ marginTop: 4 }}>
                    <label className="cc-label">{t('CC_PARTIES_WORK_DESC_LABEL')}</label>
                    <input
                        className={`cc-input${errors.workDescription ? ' cc-input--error' : ''}`}
                        value={workDescription}
                        onChange={e => { setWorkDescription(e.target.value); clearError('workDescription'); }}
                        placeholder={t('CC_PARTIES_WORK_DESC_HINT')}
                    />
                    {errors.workDescription && <span className="cc-field-error">{errors.workDescription}</span>}
                </div>

                <div className="cc-field" style={{ marginTop: 4 }}>
                    <label className="cc-label">{t('CC_PARTIES_SPECIAL_TERMS_LABEL')}</label>
                    <textarea
                        className="cc-textarea"
                        value={specialTerms}
                        onChange={e => setSpecialTerms(e.target.value)}
                        placeholder={t('CC_PARTIES_SPECIAL_TERMS_HINT')}
                        rows={3}
                    />
                </div>

            </div>
        </div>

        <AddCustomerModal
            show={showAddModal}
            onHide={() => setShowAddModal(false)}
            onSave={() => {
                setShowAddModal(false);
                onCustomerAdded();
            }}
            
        />
        </>
    );
};

export default Step1Parties;
